import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import NiceModal, { useModal } from "@ebay/nice-modal-react";
import NodeForm from "../Forms/NodeForm";
import Button from "components/Elements/Button";
import { clearSavedNode } from "actions/workflows";

const AddNodeModal = NiceModal.create(({ node = {}, archive_id = null }) => {
  const dispatch = useDispatch();
  const { savedNode } = useSelector((state) => state.workflows);
  const [showModal, setShowModal] = useState(true);
  const modal = useModal();

  console.log("!!! NODE EDIT ARCHIVE ID: ", archive_id);

  const hide = (e) => {
    if (e) {
      e.stopPropagation();
    }
    dispatch(clearSavedNode());

    modal.resolve(localNode);
    modal.remove();
  };

  const cloneNode = (node) => {
    const u = {
      id: "",
      public_id: "",
      name: "",
      description: "",
    };
    Object.keys(node).forEach((key) => {
      u[key] = node[key];
    });
    return u;
  };

  const [localNode, setLocalNode] = useState(cloneNode(node));

  useEffect(() => {
    if (savedNode) {
      setLocalNode(cloneNode(savedNode));
    }
  }, [savedNode]);

  return (
    <div style={{ display: showModal ? "block" : "none" }}>
      <div className="w-9/12 force-height-90 shadow-lg force-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
        <div className="relative h-full w-full my-6 mx-auto max-w-3xl">
          {/*content*/}
          <div className="border-0 relative flex flex-col w-full bg-white outline-none focus:outline-none">
            {/*header*/}
            <div className="flex items-start justify-between p-5 border-b border-solid border-blueGray-200 rounded-t">
              <h3 className="text-3xl font-semibold">
                {node.id ? `Edit Node - ${node.name}` : "Add Node"}
              </h3>
              <Button
                style={{ marginLeft: "10px" }}
                onClick={() => {
                  setShowModal(false);
                  NiceModal.show("test-node", {
                    node_id: localNode.public_id,
                  }).then(() => {
                    setShowModal(true);
                  });
                }}
              >
                Test
              </Button>

              <button
                className="p-1 ml-auto bg-transparent border-0 text-black opacity-5 float-right text-3xl leading-none font-semibold outline-none focus:outline-none"
                onClick={hide}
              >
                <span className="bg-transparent text-black opacity-5 h-6 w-6 text-2xl block outline-none focus:outline-none">
                  ×
                </span>
              </button>
            </div>
            {/*body*/}
            <div className="relative p-6 flex-auto ">
              <NodeForm
                node_id={localNode.public_id}
                archive_id={archive_id}
                clickedClose={hide}
                onSaved={(node) => {
                  console.log("!!! SAVED LOCAL: ", node);
                  setLocalNode(node);
                }}
              />
            </div>
          </div>
        </div>
      </div>
      <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
    </div>
  );
});

export default AddNodeModal;
